import { LOAD_CUSTOMCONTENT_SUCCESS, LOAD_CUSTOMCONTENT_FAILURE, LOAD_CUSTOMCONTENT_REQUEST } from './actionTypes';

export function loadCustomContentSuccess(customContent) {
    return { type: LOAD_CUSTOMCONTENT_SUCCESS, customContent };
}

export function loadCustomContentRequest() {
    return { type: LOAD_CUSTOMCONTENT_REQUEST };
}

export function loadCustomContentError() {
    return { type: LOAD_CUSTOMCONTENT_FAILURE };
}